// Keeps other query params + hash; no reload.
// Returns true if the URL changed (any param was removed).
export default function stripQueryParamsFromUrl(paramNames = []) {
  try {
    if (!Array.isArray(paramNames) || paramNames.length === 0) return false;

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    let changed = false;

    for (const name of paramNames) {
      if (params.has(name)) {
        params.delete(name);           // deletes all occurrences of the key
        changed = true;
      }
    }

    if (!changed) return false;

    const newSearch = params.toString();
    const newUrl = url.pathname + (newSearch ? `?${newSearch}` : "") + url.hash;
    window.history.replaceState(null, "", newUrl);
    return true;
  } catch {
    return false;
  }
}

// Optional convenience wrappers (import if you like):
export const stripQlikTicketFromUrl = () => stripQueryParamsFromUrl(["qlikTicket"]);
export const stripBookmarkFromUrl   = () => stripQueryParamsFromUrl(["bookmark"]);
export const stripSelectFromUrl     = () => stripQueryParamsFromUrl(["select"]);
